import { IonRouterOutlet, IonSplitPane } from '@ionic/react'
import { Route } from 'react-router-dom';
// Components
// import Menu from '../components/Menu/Menu'
import Login from './Login/Login';
// import Home from './Home/Home';
import Crop from './Crop/Crop';
import Update from './Update/Update';
import Content from './Content/Content';
import PreviewPage from './PreviewPage/PreviewPage';
import ClassVerification from './ClassVerification/ClassVerification';
import UserVerification from './UserVerification/UserVerification';
import AddUser from './TeacherPages/AddUser/AddUser'; // Teacher
import TeachersHomePage from './TeacherPages/TeachersHomePage/TeachersHomePage'; // Teacher
import CreateID from './TeacherPages/CreateID/CreateID'; // Teacher
import VerifyID from './TeacherPages/VerifyID/VerifyID'; // Teacher
// import TeacherIDCards from './TeacherPages/TeacherIDCards/TeacherIDCards'; // Teacher
import TeacherContent from './TeacherPages/TeacherContent/TeacherContent'; // Teacher
import VerificationStatus from './VerificationStatus/VerificationStatus';
import IdCardVerification from './VerificationStatus/IdCardVerification';
import LandingPage from './LandingPage/LandingPage';

function Layout() {
    return (
        <IonSplitPane contentId="main">
            {/* <Menu /> */}
            <IonRouterOutlet id="main">
                <Route path="/" exact={true} component={LandingPage} />
                <Route path="/class-verification" exact={true} component={ClassVerification} />
                <Route path="/login" exact={true} component={Login} />
                <Route path="/signup" exact={true} component={UserVerification} />
                <Route path="/verification-status" exact={true} component={VerificationStatus} />
                <Route path="/idcard-verification-status" exact={true} component={IdCardVerification} />
                <Route path="/home" exact={true} component={Content} />
                {/* <Route path="/home" exact={true} component={Home} /> */}
                {/* <Route path="/content" exact={true} component={Content} /> */}
                <Route path="/update" exact={true} component={Update} />
                <Route path="/crop" exact={true} component={Crop} />
                <Route path="/preview" exact={true} component={PreviewPage} />

                {/* Teacher */}
                {/* <Route path="/teacher/home" exact={true} component={TeachersHomePage} />
                <Route path="/teacher/content" exact={true} component={TeacherContent} />
                <Route path="/teacher/add-user" exact={true} component={AddUser} />
                <Route path="/teacher/verify-id" exact={true} component={VerifyID} />
                <Route path="/teacher/create-id" exact={true} component={CreateID} /> */}
                {/* <Route path="/teacher/create-id/:name/:id" exact={true} component={TeacherIDCards} /> */}
            </IonRouterOutlet>
        </IonSplitPane>
    )
}

export default Layout